var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InlineList',{attrs:{"items":_vm.filters,"separator":_vm.$listeners.remove ? 'space' : null,"get-key":function (filter) { return filter.id; }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('FilterItem',_vm._g({attrs:{"filter":item,"nowrap":_vm.nowrap}},_vm.$listeners))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }